import axios from "axios";

const API_URL = process.env.BACKEND_URL;

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to every request if exists
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-accounting-auth'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default instance;